import { Button } from "react-bootstrap";
import useDarkMode from "../hooks/useDarkMode";

export default function PaginationControls({
  currentPage,
  totalPages,
  onPrev,
  onNext,
  size = "sm",
  className = "pt-2",
}) {
  const isDarkMode = useDarkMode();

  if (totalPages <= 1) return null;

  return (
    <div className={`d-flex justify-content-between align-items-center ${className}`.trim()}>
      <Button
        variant={isDarkMode ? "outline-light" : "outline-secondary"}
        size={size}
        disabled={currentPage <= 1}
        onClick={onPrev}
      >
        이전
      </Button>
      <span
        className="text-secondary fs-sm"
        style={{ color: isDarkMode ? "rgba(255, 255, 255, 0.85)" : undefined }}
      >
        {currentPage} / {totalPages}
      </span>
      <Button
        variant={isDarkMode ? "outline-light" : "outline-secondary"}
        size={size}
        disabled={currentPage >= totalPages}
        onClick={onNext}
      >
        다음
      </Button>
    </div>
  );
}
